import React, { useState, useEffect, useRef } from "react";
import BreadCrumbComponent from "../../../components/BreadCrumbComponent";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useTranslation } from "react-i18next";
import VerticalLinearStepper from "../../Add New/Stepper";
import Invalid from "../../../assets/Icon/invalid.svg";
import moment from "moment/moment";
import ApiCalling from "../../../network/ApiCalling";
import Util from "../../../Util";
import DatePicker from "react-datepicker";
import Calender from "../../../assets/Icon/calendar.svg";
import ToastHOC from "../../HOC/ToastHOC";
import Delete from "../../../assets/Icon/delete.svg";

const NewCreateBillingPlan = (props) => {
  const { setIsToast } = props;
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  const { t } = useTranslation();
  const school = Util.getSelectedSchool();
  const [activeStep, setActiveStep] = useState(0);
  const [indexPage, setIndexPage] = useState(0);
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");
  const [isStateUpdated, setIsStateUpdated] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [startDateError, setStartDateError] = useState("");
  const [period, setPeriod] = useState("");
  const [periodError, setPeriodError] = useState("");
  const [endDate, setEndDate] = useState(null);
  const [endDateError, setEndDateError] = useState("");
  const [feeTypeList, setFeeTypeList] = useState([]);
  const [enabledEndDates, setEnabledEndDates] = useState([]);
  const [lastPaymentDaysList, setLastPaymentDaysList] = useState([]);
  const [lastPaymentDay, setLastPaymentDay] = useState(0);
  const [lastPaymentDayError, setLastPaymentDayError] = useState("");
  const [termsId, setTermsId] = useState(0);
  const [terms, setTerms] = useState([]);
  const [taxList, setTaxList] = useState([]);
  const [selectTax, setSelectTax] = useState(false);
  const [billPlanList, setBillPlanList] = useState([]);
  const [fields, setFields] = useState([
    {
      id: 1,
      taxId: 0,
      taxPercentage: 0,
    },
  ]);
  const [fieldError, setFieldError] = useState(false);
  const [subTotalAmount, setSubTotalAmount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalTaxAmount, setTotalTaxAmount] = useState(0);
  const [stepper, setStepper] = useState(false);
  const [feeTypefields, setFeeTypeFields] = useState([
    {
      id: 1,
      feeTypeId: 0,
      amount: "",
    },
  ]);
  const [fieldFeeTypeError, setFeeTypeFieldError] = useState(false);
  const [discount, setDiscount] = useState(false);
  const [discountType, setDiscountType] = useState("");
  const [discountTypeError, setDiscountTypeError] = useState("");
  const [discountAmount, setDiscountAmount] = useState(0);
  const [discountAmountError, setDiscountAmountError] = useState("");
  const datepickerRef = useRef(null);
  const [gradeId, setGradeId] = useState(0);
  const [gradeList, setGradeList] = useState([]);
  const [monday, setMonday] = useState(false);
  const [tuesday, setTuesday] = useState(false);
  const [wednesday, setWednesday] = useState(false);
  const [thursday, setThursday] = useState(false);
  const [friday, setFriday] = useState(false);
  const [timingList, setTimingList] = useState([]);
  const [timingId, settimingId] = useState(0);
  const currency = Util.getSelectedSchool()?.currency;
  const [showNotification, setShowNotification] = useState(false);
  const [toastTitle, setToastTitle] = useState("");
  const [toastSubtitle, setToastSubtitle] = useState("");
  const [toastType, setToastType] = useState("success");
  const [emailNotify, setEmailNotify] = useState(true);
  const [item, setItem] = useState({});
  const [countofDays, setCountofDays] = useState(0);
  const [invoiceCount, setInvoiceCount] = useState(0);

  useEffect(() => {
    if (props?.location) {
      if (props?.location?.item) {
        setItem(props?.location?.item);
        console.log(props?.location?.item);
      }
    }
  }, [props]);

  const periodList = [
    // { value: "WEEKLY", name: "WEEKLY" },
    // { value: "BY-WEEKLY", name: "BY-WEEKLY" },
    { value: "MONTHLY", name: "MONTHLY" },
    { value: "QUARTERLY", name: "QUARTERLY" },
    { value: "ONE TIME", name: "ONE TIME" },
  ];

  const CustomInput = React.forwardRef(
    ({ value, onClick, icon, hasError }, ref) => (
      <div className="d-flex" onClick={onClick}>
        <input
          ref={ref}
          className={`custom-input__field ${
            hasError ? "datePicker-error" : ""
          }`}
          value={value}
          readOnly
        />
        <div className="custom-input__icon">
          <img src={icon} alt="Calander" className="svg-icon  calender-icon" />
        </div>
      </div>
    )
  );
  const handleStartDate = (date) => {
    setStartDate(date);
    setStartDateError("");
    setEndDate(null);
    getSelectedPeriod(period, date);
    if (period == "ONE TIME") {
      setEndDate(date);
    }
    setIsStateUpdated(true);
  };

  const handleLastPaymentDay = (e) => {
    const days = e.target.value;
    setLastPaymentDay(days);
    setLastPaymentDayError("");
    setIsStateUpdated(true);
  };

  const getSelectedPeriod = (period, date) => {
    if (period === "WEEKLY") {
      const startDateObj = new Date(date);
      const endDateObj = new Date("2099-12-31");
      const enabledDates = [];
      enabledDates.push(startDateObj);

      let currentDate = new Date(startDateObj);
      while (currentDate < endDateObj) {
        currentDate.setDate(currentDate.getDate() + 7);
        enabledDates.push(new Date(currentDate));
      }
      const formattedDate = enabledDates.map((d) =>
        moment(d).format("YYYY-MM-DD")
      );

      setEnabledEndDates(formattedDate);
      fillDays(7);
    } else if (period === "BY-WEEKLY") {
      const startDateObj = new Date(date);
      const endDateObj = new Date("2099-12-31");
      const enabledDates = [];
      enabledDates.push(startDateObj);

      let currentDate = new Date(startDateObj);
      while (currentDate < endDateObj) {
        currentDate.setDate(currentDate.getDate() + 14);
        enabledDates.push(new Date(currentDate));
      }
      const formattedDate = enabledDates.map((d) =>
        moment(d).format("YYYY-MM-DD")
      );

      setEnabledEndDates(formattedDate);
      fillDays(15);
    } else if (period === "MONTHLY") {
      const startDateObj = new Date(date);
      const endDateObj = new Date("2099-12-31");
      const enabledDates = [];
      enabledDates.push(startDateObj);

      let currentDate = new Date(startDateObj);
      while (currentDate < endDateObj) {
        currentDate.setMonth(currentDate.getMonth() + 1);
        enabledDates.push(new Date(currentDate));
      }
      const formattedDate = enabledDates.map((d) =>
        moment(d).format("YYYY-MM-DD")
      );
      setEnabledEndDates(formattedDate);
      fillDays(30);
    } else if (period === "QUARTERLY") {
      const startDateObj = new Date(date);
      const endDateObj = new Date("2099-12-31");
      const enabledDates = [];
      enabledDates.push(startDateObj);

      let currentDate = new Date(startDateObj);
      while (currentDate < endDateObj) {
        currentDate.setMonth(currentDate.getMonth() + 3);
        enabledDates.push(new Date(currentDate));
      }
      const formattedDate = enabledDates.map((d) =>
        moment(d).format("YYYY-MM-DD")
      );
      setEnabledEndDates(formattedDate);
      fillDays(30);
    } else if (period === "ONE TIME") {
      // handleEndDate(new Date(date))
      // console.log(date)
      fillDays(30);
    } else {
      setEnabledEndDates([]);
    }
  };

  const handlePeriod = (e) => {
    setIsStateUpdated(true);
    const selectedPeriod = e.target.value;
    setPeriod(selectedPeriod);
    setPeriodError("");
    getSelectedPeriod(selectedPeriod, startDate);
    if (selectedPeriod == "ONE TIME") {
      setEndDate(startDate);
      setEndDateError("");
    } else {
      setEndDate(null);
    }
  };

  const fillDays = (days) => {
    const arr = [];
    for (var i = 1; i < days; i++) {
      arr.push({ value: i, name: i + " day(s) after invoice generation date" });
    }
    setLastPaymentDaysList(arr);
  };

  const handleEndDate = (date) => {
    setEndDate(date);
    setIsStateUpdated(true);
    setEndDateError("");
  };

  const handleTerms = (e) => {
    setTermsId(e.target.value);
    setIsStateUpdated(true);
  };

  const handleGrade = (e) => {
    setGradeId(e.target.value);
    setIsStateUpdated(true);
  };

  const handleTiming = (e) => {
    settimingId(e.target.value);
    setIsStateUpdated(true);
  };

  const handleCountOfDays = (e) => {
    setCountofDays(e.target.value);
    setIsStateUpdated(true);
  };

  const handleSelectTax = (e) => {
    setSelectTax(e.target.checked);
    setIsStateUpdated(true);
    if (e.target.checked == false) {
      setFields([
        {
          id: 1,
          taxId: 0,
          taxPercentage: 0,
        },
      ]);
      setFieldError(false);
      // setTotalAmount(0);
      // setTotalTaxAmount(0);
      // setSubTotalAmount(0);
    } else {
      // setTotalAmount(amount);
      setTotalTaxAmount(0);
      // setSubTotalAmount(amount);
    }
  };
  const handleTax = (index, event) => {
    // setIsStateUpdated(true);
    // const newFields = [...fields];
    // const filteredData = taxList.filter((it) => it.id == event.target.value);
    // newFields[index]["taxId"] = event.target.value;
    // newFields[index]["taxPercentage"] = filteredData[0]?.tax_percentage;
    // setFields(newFields);

    // let total;
    // let taxDetails = newFields.map((ele) => {
    //   const taxAmount =
    //     (ele.taxPercentage / 100) * Number(subTotalAmount - discountAmount);
    //   return { taxName: ele.taxId, taxAmount };
    // });
    // total =
    //   Number(subTotalAmount - discountAmount) +
    //   taxDetails.reduce((sum, tax) => sum + tax.taxAmount, 0);
    // const sum = taxDetails.reduce(
    //   (acc, field) => acc + Number(field.taxAmount),
    //   0
    // );
    // // setTotalAmount(total);
    // setTotalTaxAmount(sum);
    setIsStateUpdated(true);

    const newFields = [...fields];
    const selectedTaxId = parseInt(event.target.value);
    const filteredData = taxList.filter((it) => it.id === selectedTaxId);

    const taxPercentage = filteredData[0]?.tax_percentage || 0;
    const taxAmount =
      (taxPercentage / 100) * Number(subTotalAmount - discountAmount);

    newFields[index] = {
      ...newFields[index],
      taxId: selectedTaxId,
      taxPercentage: taxPercentage,
      taxAmount: taxAmount,
    };
    // console.log("FIELDS", newFields);
    setFields(newFields);

    const sum = newFields.reduce(
      (acc, ele) => acc + Number(ele.taxAmount || 0),
      0
    );

    setTotalTaxAmount(sum);
  };

  const handleAddField = () => {
    setIsStateUpdated(true);
    setFields([
      ...fields,
      {
        id: fields.length + 1,
        taxId: 0,
        taxPercentage: 0,
      },
    ]);
  };

  const handleRemoveField = (index) => {
    if (fields.length <= 1) {
      setFields([
        {
          id: 1,
          taxId: 0,
          taxPercentage: 0,
        },
      ]);
      setTotalTaxAmount(0);
      // setTotalAmount(subTotalAmount - discountAmount);
      return;
    }
    setIsStateUpdated(true);
    const newFields = fields.filter((field, i) => i !== index);
    setFields(newFields);
    let total;
    let taxDetails = newFields.map((ele) => {
      const taxAmount =
        (ele.taxPercentage / 100) * Number(subTotalAmount - discountAmount);
      return { taxName: ele.taxId, taxAmount };
    });
    total =
      Number(subTotalAmount - discountAmount) +
      taxDetails.reduce((sum, tax) => sum + tax.taxAmount, 0);
    const sum = taxDetails.reduce(
      (acc, field) => acc + Number(field.taxAmount),
      0
    );
    // setSubTotalAmount(subTotalAmount - discountAmount);
    // setTotalAmount(total);
    setTotalTaxAmount(sum);
  };

  const handleFeeTypeAddField = () => {
    setIsStateUpdated(true);
    setFeeTypeFields([
      ...feeTypefields,
      {
        id: feeTypefields.length + 1,
        feeTypeId: 0,
        amount: "",
      },
    ]);
  };

  const handleFeeTypeRemoveField = (index) => {
    setIsStateUpdated(true);
    setFeeTypeFields(feeTypefields.filter((field, i) => i !== index));
  };

  const handleInputChange = (index, event) => {
    setIsStateUpdated(true);
    const newFields = [...feeTypefields];
    newFields[index][event.target.name] = event.target.value;
    setFeeTypeFields(newFields);
    calculateSubTotal();
  };

  const handleFeeTypeId = (index, event) => {
    setIsStateUpdated(true);
    const newFields = [...feeTypefields];
    newFields[index]["feeTypeId"] = event.target.value;
    newFields[index][event.target.name] = event.target.value;
    // setFields(newFields);
    setFeeTypeFields(newFields);
  };

  const handleDiscount = (e) => {
    setDiscount(e.target.checked);
    setIsStateUpdated(true);
    if (!discount) {
      setDiscountType("");
      setDiscountAmount(0);
    }
  };

  const handleNotify = (e) => {
    setEmailNotify(e.target.checked);
    setIsStateUpdated(true);
  };

  const handleDiscountType = (e) => {
    setDiscountType(e.target.value);
    setDiscountTypeError("");
    setIsStateUpdated(true);
  };
  const handleDiscountAmount = (e) => {
    const amount = e.target.value;
    setDiscountAmount(amount);
    setDiscountAmountError("");
    // setTotalAmount(subTotalAmount - Number(amount));
    setIsStateUpdated(true);
  };

  const feeTypeData = () => {
    ApiCalling.apiCallBodyDataGet("fee-types/list")
      .then((res) => {
        setFeeTypeList(res.data || []);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const termsData = () => {
    ApiCalling.apiCallBodyDataGet("terms/school")
      .then((res) => {
        setTerms(res.data || []);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const generateInvoices = (startDate, endDate, period) => {
    if (!startDate || !period || !endDate) return [];

    const invoices = [];
    const start = moment(startDate);
    const end = moment(endDate);

    let current = start.clone();

    if (period === "ONE TIME") {
      invoices.push(current.format("YYYY-MM-DD"));
    } else {
      let increment;
      switch (period) {
        case "WEEKLY":
          increment = { days: 7 };
          break;
        case "BY-WEEKLY":
          increment = { days: 14 };
          break;
        case "MONTHLY":
          increment = { months: 1 };
          break;
        case "QUARTERLY":
          increment = { months: 3 };
          break;
        default:
          return [];
      }

      while (current.isSameOrBefore(end)) {
        invoices.push(current.format("YYYY-MM-DD"));
        current = current.clone().add(increment);
      }
    }
    return invoices;
  };

  useEffect(() => {
    feeTypeData();
    termsData();
    getTaxList();
    setStepper(true);
    getGradeList();
    getTimingList();
  }, []);

  useEffect(() => {
    console.log("getBillPlanList useEffect");
    let mounted = true;

    const getBillPlanList = () => {
      setIsLoading(true);
      ApiCalling.apiCallBodyDataGet("billing-plans/saved")
        .then((res) => {
          if (mounted) {
            setIsLoading(false);
            setBillPlanList(res.data);
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    };

    getBillPlanList();

    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    if (item && Object.keys(item).length !== 0) {
      setName(item.name);
      setStartDate(
        Util.isValidData(item.start_date) ? new Date(item.start_date) : null
      );
      setPeriod(item.period);
      setEndDate(
        Util.isValidData(item.end_date) ? new Date(item.end_date) : null
      );
      setLastPaymentDay(item.last_payment_date);
      getSelectedPeriod(item.period, item.start_date);
      setTermsId(item.terms_id);

      // Set Charges
      if (item?.BillingInvoiceFee && item?.BillingInvoiceFee.length > 0) {
        const fields = item.BillingInvoiceFee.map((feetype, index) => ({
          id: index + 1,
          feeTypeId: feetype.Fee_Type.id,
          amount: feetype.total,
        }));
        setFeeTypeFields(fields);
      }

      // Set Taxes
      if (item?.BillingPlanTax && item.BillingPlanTax.length > 0) {
        const taxFields = item.BillingPlanTax.map((billingPlanTax, index) => {
          const taxPercentage = billingPlanTax.Tax?.tax_percentage || 0;
          const taxAmount = (taxPercentage / 100) * Number(item.amount);

          return {
            id: index + 1,
            taxId: billingPlanTax.tax_id,
            taxPercentage,
            taxAmount,
          };
        });

        setSelectTax(true);
        setFields(taxFields);

        const taxSum = taxFields.reduce(
          (acc, field) => acc + Number(field.taxAmount || 0),
          0
        );

        const totalAmount = Number(item.amount) + taxSum;

        setSubTotalAmount(item.amount);
        setTotalAmount(totalAmount);
        setTotalTaxAmount(taxSum);
      } else {
        // No tax applied
        setSelectTax(false);
        setFields([]);
        setTotalTaxAmount(0);
      }

      // Set Discount
      setDiscountType(item?.discount_type || "");
      setDiscountAmount(item?.discount_amount || "");

      if (item?.discount_amount && Number(item.discount_amount) > 0) {
        setDiscount(true);
      } else {
        setDiscount(false);
      }

      // Other Fields
      setGradeId(item.grade_id == null ? 0 : item?.grade_id);
      settimingId(item.timing_id == null ? 0 : item?.timing_id);
      setMonday(item.monday);
      setTuesday(item.tuesday);
      setWednesday(item.wednesday);
      setThursday(item.thursday);
      setFriday(item.friday);
      setEmailNotify(item.email_notify);
      setCountofDays(item.count_of_days);

      setTimeout(() => {
        calculateSubTotal();
        calculateTotal();
      }, 0);
    }
    console.log("AMOUNT", totalAmount, subTotalAmount);
  }, [item]);

  const reset = () => {
    setName("");
    setStartDate(null);
    setPeriod("");
    setEndDate(null);
    // setSaveInLibrary(false);
    setNameError("");
    setStartDateError("");
    setEndDateError("");
    setPeriodError("");
    // setBillingPlanLibraryId(0);
    setLastPaymentDay(0);
    setLastPaymentDayError("");
    setTermsId(0);
    setSelectTax(false);
    setFields([
      {
        id: 1,
        taxId: 0,
        taxPercentage: 0,
      },
    ]);
    setFieldError(false);
    setFeeTypeFields([
      {
        id: 1,
        feeTypeId: 0,
        amount: "",
      },
    ]);
    setFeeTypeFieldError(false);
    setTotalAmount(0);
    setTotalTaxAmount(0);
    setSubTotalAmount(0);
    setStepper(true);
    setDiscount(false);
    setDiscountType("");
    setDiscountAmount(0);
    setDiscountTypeError("");
    setDiscountAmountError("");
    setGradeId(0);
    settimingId(0);
    setMonday(false);
    setTuesday(false);
    setWednesday(false);
    setThursday(false);
    setFriday(false);
    setCountofDays(0);
    setInvoiceCount(0);
  };

  const getTaxList = () => {
    setIsLoading(true);
    ApiCalling.apiCallParamsGet("tax/school")
      .then((res) => {
        setTaxList(res.data);
        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  const getGradeList = () => {
    setIsLoading(true);
    ApiCalling.apiCallBodyDataGet("grade/list")
      .then((res) => {
        console.log("DATA", res.data);
        setGradeList(res.data);
        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  const getTimingList = () => {
    ApiCalling.apiCallBodyDataGet("timing/list").then((res) => {
      setTimingList(res.data);
    });
  };

  const steps = [
    {
      label: `${t("Plan Details")}`,
    },
    {
      label: `${t("Invoice Details")}`,
    },
    {
      label: `${t("Notifications")}`,
    },
  ];

  const handleBack = () => {
    if (indexPage === 0) {
      history.push({
        pathname: "/bill-Dashboard",
        tab: "2",
      });
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
      setIndexPage((indexPage) => indexPage - 1);
    }
  };

  const handleReset = () => {
    setActiveStep(0);
    setIndexPage(0);
  };

  const handleNext = () => {
    if (indexPage === 0) {
      step1();
    }
    if (indexPage === 1) {
      step2();
    }
    if (indexPage === 2) {
      step3();
    }
  };

  const step1 = () => {
    let error = false;
    setNameError("");
    setStartDateError("");
    setEndDateError("");
    setPeriodError("");
    setLastPaymentDayError("");
    if (!name || name.trim() === "") {
      setNameError(t("Name is required"));
      error = true;
    }
    if (startDate == null) {
      setStartDateError(t("Start Date is required"));
      error = true;
    }
    if (endDate == null) {
      setEndDateError(t("End Date is required"));
      error = true;
    }
    if (period === "") {
      setPeriodError(t("Period is required"));
      error = true;
    }
    if (lastPaymentDay === 0) {
      setLastPaymentDayError(t("Due Date is required"));
      error = true;
    }
    if (!error) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      setIndexPage((indexPage) => indexPage + 1);
      console.log(monday, tuesday, wednesday, thursday, friday);
      console.log(
        name,
        startDate,
        endDate,
        period,
        lastPaymentDay,
        termsId,
        timingId,
        gradeId
      );
    }
  };
  const step2 = () => {
    let error = false;
    setFieldError(false);
    setFeeTypeFieldError(false);
    setDiscountTypeError("");
    setDiscountAmountError("");
    setIsStateUpdated(false);
    fields.map((f) => {
      if (selectTax && f.taxId == 0) {
        setFieldError(true);
        error = true;
      }
    });
    feeTypefields.map((f) => {
      if (f.feeTypeId == 0 || f.amount == "") {
        setFeeTypeFieldError(true);
        error = true;
      }
    });
    if (discount && (discountType == "" || discountType.trim() === "")) {
      setDiscountTypeError(t("Discount Type is required"));
      error = true;
    }
    if (discount && discountAmount == 0) {
      setDiscountAmountError(t("Discount Amount is required"));
      error = true;
    }
    if (!error) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      setIndexPage((indexPage) => indexPage + 1);
    }
  };
  const step3 = () => {
    setIsLoading(true);
    const start_date = moment(startDate).format("YYYY-MM-DD");
    const end_date = moment(endDate).format("YYYY-MM-DD");
    const data = {
      name: name,
      start_date: start_date,
      end_date: end_date,
      period: period,
      // save_in_library: saveInLibrary,
      last_payment_date: lastPaymentDay,
      terms_id: termsId,
      tax_id: fields.map((it) => it.taxId),
      fee_type_ids: feeTypefields,
      discount_amount: discountAmount === "" ? 0 : discountAmount,
      discount_type: discountType,
      amount: totalAmount,
      sub_total: subTotalAmount,
      monday: monday,
      tuesday: tuesday,
      wednesday: wednesday,
      thursday: thursday,
      friday: friday,
      grade_id: gradeId !== 0 ? gradeId : null,
      timing_id: timingId !== 0 ? timingId : null,
      email_notify: emailNotify,
      count_of_days: countofDays,
    };
    console.log("DA", data);
    if (item && Object.keys(item).length !== 0) {
      ApiCalling.apiCallBodyDataPost(
        `billing-plans/updatePlan/${item.id}`,
        data
      )
        .then((res) => {
          if (res.data?.status === true) {
            setIsLoading(false);
            // onSave(res.data.message);
            // onClose();
            reset();
            setIsToast(`Billing Plan Updated Successfully`);
            setTimeout(() => {
              history.push({
                pathname: "/bill-Dashboard",
                pendingToast: `Billing Plan Updated Successfully`,
                tab: "2",
              });
            }, 500);
          } else {
            setIsLoading(false);
            setShowNotification(true);
            setToastType("error");
            setToastTitle("Error");
            setToastSubtitle(res.data?.message);
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    } else {
      ApiCalling.apiCallBodyDataPost("billing-plans/add", data)
        .then((res) => {
          if (res.data?.status === true) {
            setIsLoading(false);
            reset();
            // onSave(res.data.message);
            // onClose();
            // updateData();
            setIsToast(`Billing Plan Added Successfully`);
            setTimeout(() => {
              history.push({
                pathname: "/bill-Dashboard",
                pendingToast: `Billing Plan Added Successfully`,
                tab: "2",
              });
            }, 500);
          } else {
            setIsLoading(false);
            setShowNotification(true);
            setToastType("error");
            setToastTitle("Error");
            setToastSubtitle(res.data?.message);
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    }
  };

  const calculateSubTotal = () => {
    const total = feeTypefields.reduce((sum, item) => {
      const amt = parseFloat(item.amount);
      return sum + (isNaN(amt) ? 0 : amt);
    }, 0);
    setSubTotalAmount(total);
    console.log(total);
    // setTimeout(() => {
    //   calculateTotal();
    // }, 0);
  };

  const calculateTotal = () => {
    const subTotal = parseFloat(subTotalAmount) || 0;
    const discountVal =
      discount && discountAmount ? parseFloat(discountAmount) || 0 : 0;

    let baseAmount = subTotal - discountVal;
    if (baseAmount < 0) baseAmount = 0;

    let taxTotal = 0;

    if (selectTax && fields.length > 0) {
      fields.forEach((f) => {
        const percent = parseFloat(f.taxPercentage);
        if (!isNaN(percent)) {
          taxTotal += (baseAmount * percent) / 100;
        }
      });
    }

    const total = baseAmount + taxTotal;
    setTotalAmount(total);
    console.log(total);
  };

  useEffect(() => {
    calculateTotal();
  }, [subTotalAmount, discountAmount, fields, discount, selectTax]);
  useEffect(() => {
    calculateSubTotal();
  }, [feeTypefields]);

  useEffect(() => {
    if (startDate && period) {
      const invoices = generateInvoices(startDate, endDate, period);
      setInvoiceCount(invoices);
    }
  }, [startDate, endDate, period]);

  return (
    <>
      {!isLoading ? (
        <>
          <div className="container">
            <div className="row mb-2 py-4">
              <BreadCrumbComponent
                Breadcrumb={[
                  {
                    name: "Billing",
                    navigate: () => {
                      history.push("/bill-Dashboard");
                    },
                  },
                  {
                    name: "Billing Plan",
                    navigate: () => {
                      history.push({ pathname: "/bill-Dashboard", tab: "2" });
                    },
                  },
                  { name: `${t("Add New Billing Plan")}` },
                ]}
              />
              <div className="col-lg">
                <h2 className="page-head text-center">
                  {t("Add New Billing Plan")}
                </h2>
              </div>
            </div>
            <div className="row mt-0">
              <div className="col-lg-3">
                <VerticalLinearStepper
                  activeStep={activeStep}
                  handleNext={handleNext}
                  handleBack={handleBack}
                  handleReset={handleReset}
                  steps={steps}
                />
              </div>
              <div className="col-lg-8">
                {indexPage == 0 && (
                  <>
                    <div className="form-wrappr">
                      <h5 className="drawer-sub-header">{t("Plan Details")}</h5>
                    </div>
                    <div className="row text-start mt-3">
                      <div className="col-lg-12">
                        <div className="input-filed">
                          <span className="basic-text required">
                            {t("Plan Name")}
                          </span>
                          <input
                            className={`form-control custom-input ${
                              nameError.length > 0 ? "input-error" : ""
                            }`}
                            value={name}
                            onChange={(e) => {
                              setName(e.target.value);
                              setNameError("");
                              setIsStateUpdated(true);
                            }}
                          />
                          {nameError.length > 0 && (
                            <span className=" invalid-error">
                              <img
                                className="fa fa-exclamation-circle mr-2 invalid-svg"
                                src={Invalid}
                              />
                              {nameError}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="input-filed pb-2">
                          <span className="basic-text">{t("Terms")}</span>
                          <select
                            name=""
                            id=""
                            className="select-dropdown form-select custom-input"
                            value={termsId}
                            onChange={handleTerms}
                            disabled={
                              item &&
                              Object.keys(item).length !== 0 &&
                              item.students.length > 0
                            }
                          >
                            <option disabled value={0}>
                              {t("Select Terms")}
                            </option>
                            {terms?.map((item) => (
                              <option value={item.id} key={item.id}>
                                {item.title}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="input-filed pb-2">
                          <span className="basic-text">{t("Grade")}</span>
                          <select
                            name=""
                            id=""
                            className="select-dropdown form-select custom-input"
                            value={gradeId}
                            onChange={handleGrade}
                            disabled={
                              item &&
                              Object.keys(item).length !== 0 &&
                              item.students.length > 0
                            }
                          >
                            <option disabled value={0}>
                              {t("Select Grade")}
                            </option>
                            {gradeList?.map((item) => (
                              <option value={item.id} key={item.id}>
                                {item.title}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="input-filed ">
                          <span className="basic-text ">
                            {t("Count of days per week")}
                          </span>
                          <select
                            name=""
                            id=""
                            className="select-dropdown form-select custom-input"
                            value={countofDays}
                            onChange={handleCountOfDays}
                            disabled={
                              item &&
                              Object.keys(item).length !== 0 &&
                              item.students.length > 0
                            }
                          >
                            <option disabled value={0}>
                              {t("Select Count of Days Per Week")}
                            </option>
                            {Array.from(
                              { length: 5 },
                              (_, index) => index + 1
                            ).map((number) => (
                              <option value={number} key={number}>
                                {number}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="input-filed pb-2">
                          <span className="basic-text">{t("Timing")}</span>
                          <select
                            name=""
                            id=""
                            className="select-dropdown form-select custom-input"
                            value={timingId}
                            onChange={handleTiming}
                            disabled={
                              item &&
                              Object.keys(item).length !== 0 &&
                              item.students.length > 0
                            }
                          >
                            <option disabled value={0}>
                              {t("Select Timing")}
                            </option>
                            {timingList?.map((item) => (
                              <option value={item.id} key={item.id}>
                                {item.title}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="input-filed pb-2">
                          <span className="basic-text required">
                            {t("Generate Invoice On")}
                          </span>
                          <DatePicker
                            ref={datepickerRef}
                            selected={startDate}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            onChange={handleStartDate}
                            dateFormat={school.date_format}
                            popperPlacement="top"
                            customInput={
                              <CustomInput
                                icon={Calender}
                                hasError={startDateError.length > 0}
                              />
                            }
                            disabled={
                              item &&
                              Object.keys(item).length !== 0 &&
                              item.students.length > 0
                            }
                          />

                          {startDateError.length > 0 && (
                            <span className="text-danger invalid-error">
                              <img
                                className="fa fa-exclamation-circle mr-2 invalid-svg"
                                src={Invalid}
                                alt="Invalid Icon"
                              />
                              {startDateError}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <span className="basic-text required">
                          {t("Billing Cycle")}
                        </span>
                        <div className="input-filed pb-2">
                          <select
                            name=""
                            id=""
                            className={`select-dropdown  form-select ${
                              periodError.length > 0
                                ? "input-error"
                                : "custom-input"
                            }`}
                            value={period}
                            onChange={handlePeriod}
                            disabled={
                              !startDate ||
                              (item &&
                                Object.keys(item).length !== 0 &&
                                item.students.length > 0)
                            }
                          >
                            <option disabled value="">
                              {t("Select Period")}
                            </option>
                            {periodList?.map((item) => (
                              <option value={item.value} key={item.value}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                          {periodError.length > 0 && (
                            <span className="text-danger invalid-error">
                              <img
                                className="fa fa-exclamation-circle mr-2 invalid-svg"
                                src={Invalid}
                                alt="Invalid Icon"
                              />
                              {periodError}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="input-filed pb-2">
                          <span className="basic-text required">
                            {t("Last invoice will generate on?")}
                          </span>
                          <DatePicker
                            selected={endDate}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            onChange={handleEndDate}
                            dateFormat={school.date_format}
                            customInput={
                              <CustomInput
                                icon={Calender}
                                hasError={endDateError.length > 0}
                              />
                            }
                            popperPlacement="top"
                            disabled={
                              !period ||
                              (Object.keys(item).length !== 0 &&
                                item.students.length > 0) ||
                              period === "ONE TIME"
                            }
                            filterDate={(d) =>
                              enabledEndDates.includes(
                                moment(d).format("YYYY-MM-DD")
                              )
                            }
                          />
                          {endDateError.length > 0 && (
                            <span className="text-danger invalid-error">
                              <img
                                className="fa fa-exclamation-circle mr-2 invalid-svg"
                                src={Invalid}
                                alt="Invalid Icon"
                              />
                              {endDateError}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="input-filed pb-2">
                          <span className="basic-text required">
                            {t("Due Date")}
                          </span>
                          <select
                            name=""
                            id=""
                            className={`select-dropdown form-select ${
                              lastPaymentDayError.length > 0
                                ? "input-error"
                                : "custom-input"
                            }`}
                            value={lastPaymentDay}
                            onChange={handleLastPaymentDay}
                            disabled={
                              !startDate ||
                              (Object.keys(item).length !== 0 &&
                                item.students.length > 0)
                            }
                          >
                            <option disabled value={0}>
                              {t("Select Days")}
                            </option>
                            {lastPaymentDaysList?.map((item) => (
                              <option value={item.value} key={item.value}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                          {lastPaymentDayError.length > 0 && (
                            <span className="text-danger invalid-error">
                              <img
                                className="fa fa-exclamation-circle mr-2 invalid-svg"
                                src={Invalid}
                                alt="Invalid Icon"
                              />
                              {lastPaymentDayError}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>

                    {Array.isArray(invoiceCount) && invoiceCount.length > 0 && (
                      <div className="row mt-2">
                        <span>
                          {invoiceCount.length} Invoice(s) will be generated
                        </span>
                      </div>
                    )}
                  </>
                )}

                {indexPage == 1 && (
                  <>
                    <div className="form-wrappr">
                      <h5 className="drawer-sub-header">
                        {t("Invoice Details")}
                      </h5>
                    </div>
                    <div className="row">
                      <div className="col-1">#</div>
                      <div className="col-lg-7">Item</div>
                      <div className="col-3">Amount</div>
                    </div>
                    <hr></hr>
                    <div className="">
                      {feeTypefields.map((f, index) => {
                        return (
                          <div
                            className="row mb-5 d-flex justify-content-center align-items-center"
                            key={index}
                          >
                            <div className="col-1">
                              {index + 1} {". "}
                            </div>
                            <div className="col-7">
                              <select
                                name="feeTypeId"
                                id="feeTypeId"
                                style={{
                                  display: "inline-block",
                                  width: "95%",
                                }}
                                className="select-dropdown form-select custom-input"
                                value={f.feeTypeId}
                                onChange={(event, i) =>
                                  handleFeeTypeId(index, event)
                                }
                                disabled={
                                  Object.keys(item).length !== 0 &&
                                  item.students.length > 0
                                }
                              >
                                <option value={0}>{t("Select Charge")}</option>
                                {feeTypeList?.map((item) => (
                                  <option value={item.id} key={item.id}>
                                    {item.type}
                                  </option>
                                ))}
                              </select>
                              {fieldFeeTypeError && f.feeTypeId == 0 && (
                                <span className="text-danger invalid-error">
                                  <img
                                    className="fa fa-exclamation-circle mr-2 invalid-svg"
                                    src={Invalid}
                                  />
                                  {t("Charge is required")}
                                </span>
                              )}
                            </div>
                            <div className="col-3">
                              <input
                                placeholder="Amount *"
                                name="amount"
                                type="number"
                                className="form-control custom-input"
                                onChange={(event) =>
                                  handleInputChange(index, event)
                                }
                                value={f.amount}
                                disabled={
                                  Object.keys(item).length !== 0 &&
                                  item.students.length > 0
                                }
                              />
                              {fieldFeeTypeError && f.amount == "" && (
                                <span className="text-danger invalid-error">
                                  <img
                                    className="fa fa-exclamation-circle mr-2 invalid-svg"
                                    src={Invalid}
                                  />
                                  {t("Amount is required")}
                                </span>
                              )}
                            </div>
                            {feeTypefields.length > 1 ? (
                              <button
                                className="col-1"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleFeeTypeRemoveField(index);
                                }}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  backgroundColor: "transparent",
                                  justifyContent: "center",
                                  // marginTop: "-20px",
                                }}
                                disabled={
                                  Object.keys(item).length !== 0 &&
                                  item.students.length > 0
                                }
                              >
                                {/* <i
                                  className="fa fa-times"
                                  aria-hidden="true"
                                ></i> */}
                                <img src={Delete} alt="Delete" width={20} />
                              </button>
                            ) : (
                              <div className="col-1"></div>
                            )}
                          </div>
                        );
                      })}
                    </div>

                    {feeTypefields.length <= 2 && (
                      <button
                        style={{
                          fontSize: "16px",
                          fontWeight: "700",
                          color: "#6418c3",
                          cursor: "pointer",
                          backgroundColor: "transparent",
                          textAlign: "left",
                        }}
                        className="mb-3"
                        onClick={handleFeeTypeAddField}
                        disabled={
                          Object.keys(item).length !== 0 &&
                          item.students.length > 0
                        }
                      >
                        + {t("Add")}
                      </button>
                    )}

                    <div className="row">
                      <div className="col-lg-8 text-right text-bold input-filed d-flex justify-content-end align-items-center">
                        {t("Sub Total")}
                      </div>
                      <div className="col-lg-3 input-filed">
                        <input
                          className="form-control"
                          value={subTotalAmount}
                          disabled
                        />
                      </div>
                    </div>

                    {discount && (
                      <div className="row mb-5 d-flex align-items-center">
                        <div className="col-1">
                          {feeTypefields.length + 1} .
                        </div>
                        <div className="col-lg-7">
                          <input
                            type="text"
                            placeholder="Discount Description"
                            className={`form-control ${
                              discountTypeError.length > 0
                                ? "input-error"
                                : "custom-input"
                            }`}
                            onChange={handleDiscountType}
                            value={discountType}
                            disabled={
                              Object.keys(item).length !== 0 &&
                              item.students.length > 0
                            }
                          />
                          {discountTypeError.length > 0 && (
                            <span className="text-danger invalid-error">
                              <img
                                className="fa fa-exclamation-circle mr-2 invalid-svg"
                                src={Invalid}
                              />
                              {discountTypeError}
                            </span>
                          )}
                        </div>
                        <div className="col-lg-3">
                          <input
                            type="number"
                            placeholder="disco  unt"
                            className={`form-control ${
                              discountAmountError.length > 0
                                ? "input-error"
                                : "custom-input"
                            }`}
                            onChange={handleDiscountAmount}
                            value={discountAmount}
                            disabled={
                              Object.keys(item).length !== 0 &&
                              item.students.length > 0
                            }
                          />
                          {discountAmountError.length > 0 && (
                            <span className="text-danger invalid-error">
                              <img
                                className="fa fa-exclamation-circle mr-2 invalid-svg"
                                src={Invalid}
                              />
                              {discountAmountError}
                            </span>
                          )}
                        </div>
                      </div>
                    )}

                    {selectTax &&
                      fields.map((f, index) => {
                        const availableTaxList = taxList?.filter(
                          (item) =>
                            !fields.some(
                              (field, i) => i != index && field.taxId == item.id
                            )
                        );

                        //serial Number logic
                        const serialNumber =
                          feeTypefields.length + (discount ? 1 : 0) + index + 1;

                        return (
                          <div
                            className="row mb-5 d-flex justify-content-center align-items-center"
                            key={index}
                          >
                            <div className="col-1">{serialNumber} .</div>
                            <div className="col-4">
                              <select
                                name="taxId"
                                id="taxId"
                                style={{
                                  display: "inline-block",
                                  width: "95%",
                                }}
                                className="select-dropdown form-select custom-input"
                                value={f.taxId}
                                onChange={(event, i) => handleTax(index, event)}
                                disabled={
                                  Object.keys(item).length !== 0 &&
                                  item.students.length > 0
                                }
                              >
                                <option value={0}>{t("Select tax")}</option>
                                {availableTaxList?.map((item) => (
                                  <option value={item.id} key={item.id}>
                                    {item.tax_name}
                                  </option>
                                ))}
                              </select>
                              {fieldError && f.taxId == 0 && (
                                <span className="text-danger invalid-error">
                                  <img
                                    className="fa fa-exclamation-circle mr-2 invalid-svg"
                                    src={Invalid}
                                  />
                                  {t("Tax is required")}
                                </span>
                              )}
                            </div>
                            <div className="col-3">
                              <input
                                placeholder="Tax Percentage"
                                name="amount"
                                type="number"
                                className="form-control custom-input"
                                value={f.taxPercentage}
                                disabled
                              />
                            </div>
                            <div className="col-3">
                              <input
                                placeholder="Tax Amount"
                                name="taxAmount"
                                type="number"
                                className="form-control custom-input"
                                value={f.taxAmount && f.taxAmount.toFixed(2)}
                                disabled
                              />
                            </div>
                            {fields.length > 1 ? (
                              <button
                                className="col-1"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleRemoveField(index);
                                }}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  backgroundColor: "transparent",
                                  justifyContent: "center",
                                  // marginTop: "-20px",
                                }}
                                disabled={
                                  Object.keys(item).length !== 0 &&
                                  item.students.length > 0
                                }
                              >
                                <img src={Delete} alt="Delete" width={20} />
                              </button>
                            ) : (
                              <div className="col-1"></div>
                            )}
                          </div>
                        );
                      })}
                    <div>
                      {selectTax && (
                        <button
                          style={{
                            fontSize: "16px",
                            fontWeight: "700",
                            color: "#6418c3",
                            cursor: "pointer",
                            backgroundColor: "transparent",
                            textAlign: "left",
                          }}
                          onClick={handleAddField}
                          disabled={
                            Object.keys(item).length !== 0 &&
                            item.students.length > 0
                          }
                        >
                          + {t("Add")}
                        </button>
                      )}
                    </div>

                    <div className="row">
                      <div className="col-lg-8 text-right text-bold input-filed d-flex justify-content-end align-items-center">
                        {t("Total")} {currency}
                      </div>
                      <div className="col-lg-3 input-filed">
                        <input
                          className="form-control"
                          value={totalAmount}
                          disabled
                        />
                      </div>
                    </div>

                    {/* checkbox */}
                    <div className="input-filed mb-2">
                      <label style={{ fontSize: "16px", fontWeight: "normal" }}>
                        <span className="mr-2">
                          <i></i>
                          {t("Discount")}
                        </span>
                        <input
                          name="holiday"
                          type="checkbox"
                          checked={discount}
                          onChange={handleDiscount}
                          disabled={
                            Object.keys(item).length !== 0 &&
                            item.students.length > 0
                          }
                        />
                        <span tabIndex={0}></span>
                      </label>
                    </div>
                    <div className="input-filed">
                      <label style={{ fontSize: "16px", fontWeight: "normal" }}>
                        <span className="mr-2">
                          <i></i>
                          {t("Tax")}
                        </span>
                        <input
                          name="tax"
                          type="checkbox"
                          checked={selectTax}
                          onChange={handleSelectTax}
                          disabled={
                            Object.keys(item).length !== 0 &&
                            item.students.length > 0
                          }
                        />
                        <span tabIndex={0}></span>
                      </label>
                    </div>
                  </>
                )}
                {indexPage == 2 && (
                  <>
                    <div className="form-wrappr">
                      <h5 className="drawer-sub-header">{t("Notification")}</h5>
                    </div>
                    <div className="input-filed mb-2">
                      <label style={{ fontSize: "16px", fontWeight: "normal" }}>
                        <input
                          name="holiday"
                          type="checkbox"
                          checked={emailNotify}
                          onChange={handleNotify}
                          className="mr-2"
                          disabled={
                            Object.keys(item).length !== 0 &&
                            item.students.length > 0
                          }
                        />
                        <span className="mr-2">
                          <i></i>
                          {t("Email Notification")}
                        </span>
                        <span tabIndex={0}></span>
                      </label>
                    </div>
                  </>
                )}

                {/* buttons */}
                {indexPage !== steps.length ? (
                  <>
                    <div className="row">
                      <div className="d-flex  align-items-center mt-3 justify-content-between">
                        <div>
                          <button
                            className="btn secondary-lg-btn"
                            onClick={handleBack}
                          >
                            {indexPage === 0 ? t("Cancel") : t("Previous")}
                          </button>
                        </div>

                        <div>
                          <button
                            className="btn primary-btn "
                            onClick={handleNext}
                          >
                            {activeStep === steps.length - 1
                              ? t("Save")
                              : t("Continue")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default ToastHOC(NewCreateBillingPlan);
